/** Inventory, character, item tooltips, shops, store, market, warehouse, reel, upgrades, skills, map. */
export default {
  // Inventory
  Inventory: "Çanta",
  "Drag to move · double-click to use": "Taşımak için sürükle · kullanmak için çift tıkla",
  "Drag to turn": "Döndürmek için sürükle",
  "Trash: drag an item here to throw it away": "Çöp: atmak için eşyayı buraya sürükle",
  Trash: "Çöp",
  Destroy: "Yok et",
  "Drag an item onto the trash to throw it away.": "Atmak için eşyayı çöpe sürükle.",
  "Take it off first, then throw it away.": "Önce çıkar, sonra at.",
  "Items from the Power Up Store cannot be thrown away.": "Power Up Mağazası eşyaları atılamaz.",
  "Destroy {item}?": "{item} yok edilsin mi?",

  // Character
  "+{n} attack power": "+{n} saldırı gücü",
  "+{n}% critical chance": "+%{n} kritik şansı",
  "+{n} max MP": "+{n} maks MP",
  "+{n} max HP": "+{n} maks HP",
  "Per point: {list}": "Puan başına: {list}",
  "No effect for a {cls} yet": "{cls} için henüz etkisi yok",
  "National Points": "Ulusal Puan",
  "Stat points": "Stat puanı",
  "Reset stats": "Statları sıfırla",
  Reset: "Sıfırla",
  Apply: "Uygula",
  Attributes: "Özellikler",
  "Click again to reset all points": "Tüm puanları sıfırlamak için tekrar tıkla",
  "Remove point": "Puan çıkar",
  "Add point": "Puan ekle",
  "No rank yet": "Henüz rütbe yok",
  "Max HP": "Maks HP",
  "Max MP": "Maks MP",
  "Attack power": "Saldırı gücü",
  "Critical chance": "Kritik şansı",
  "Attack speed": "Saldırı hızı",
  "Attack range": "Saldırı menzili",
  "{n} s": "{n} sn",
  "{n} m": "{n} m",
  "{n} min": "{n} dk",

  // Item tooltip
  Common: "Sıradan",
  Magic: "Büyülü",
  Rare: "Nadir",
  Unique: "Eşsiz",
  "Attack (item stat)": "Saldırı Gücü",
  Defense: "Savunma",
  Health: "Can",
  Mana: "Mana",
  Strength: "Güç",
  Dexterity: "Çeviklik",
  Intelligence: "Zekâ",
  Vitality: "Dayanıklılık",
  "National Points from kills": "Öldürmelerden Ulusal Puan",
  "Experience from monsters": "Canavarlardan tecrübe",
  "Gold from loot": "Ganimetten altın",
  "Defense vs Warriors": "Savaşçılara karşı savunma",
  "Defense vs Rogues": "Suikastçılara karşı savunma",
  "Defense vs Mages": "Büyücülere karşı savunma",
  "Defense vs Priests": "Rahiplere karşı savunma",
  "Flame Resistance": "Ateş Direnci",
  "Glacier Resistance": "Buz Direnci",
  "Lightning Resistance": "Yıldırım Direnci",
  "Poison Resistance": "Zehir Direnci",
  "Shadow Resistance": "Gölge Direnci",
  Resistances: "Dirençler",
  "Low tier": "Düşük kademe",
  "Mid tier": "Orta kademe",
  "High tier": "Yüksek kademe",
  "Boss unique": "Boss eşsizi",
  Tier: "Kademe",
  "Every tier": "Her kademe",
  "Flame Damage": "Alev Hasarı",
  "Glacier Damage": "Buz Hasarı",
  "Shadow Damage": "Gölge Hasarı",
  "Lightning Damage": "Yıldırım Hasarı",
  "Poison Damage": "Zehir Hasarı",
  Weapon: "Silah",
  "Off-hand": "Yan el",
  Head: "Miğfer",
  Chest: "Göğüslük",
  Hands: "Eldiven",
  Feet: "Çizme",
  Ring: "Yüzük",
  Neck: "Kolye",
  Earring: "Küpe",
  Belt: "Kemer",
  Cloak: "Pelerin",
  Glow: "Parıltı",
  Wings: "Kanatlar",
  "Use: restore {n} HP": "Kullan: {n} HP yeniler",
  "Use: restore {n} MP": "Kullan: {n} MP yeniler",
  "Used at the blacksmith for + upgrades": "Demircide + yükseltme için kullanılır",
  "Power Up Store item: cannot be thrown away": "Power Up Mağazası eşyası: atılamaz",
  "Requires level {n}": "Seviye {n} gerekir",
  "Class: {names}": "Sınıf: {names}",
  "{slot}, two-handed": "{slot}, çift el",
  Consumable: "Tüketilebilir",
  Material: "Malzeme",
  "Price: {n} NP": "Fiyat: {n} NP",
  "Price: {n} gold": "Fiyat: {n} altın",
  "Cannot be sold": "Satılamaz",
  "Sells for {n} gold": "Satış değeri: {n} altın",
  Expired: "Süresi doldu",
  "Expires in {d} d {h} h": "Bitmesine {d} g {h} sa",
  "Expires in {h} h {m} min": "Bitmesine {h} sa {m} dk",
  "Expires in {m} min": "Bitmesine {m} dk",
  weapon: "silah",
  armor: "zırh",
  accessory: "aksesuar",
  consumable: "tüketilebilir",
  material: "malzeme",
  scroll: "kağıt",

  // NPC shop and blacksmith
  Buy: "Satın al",
  Sell: "Sat",
  Upgrade: "Yükselt",
  "Cannot fail.": "Başarısız olamaz.",
  "On failure the item keeps its current level.": "Başarısız olursa eşya mevcut seviyesinde kalır.",
  "On failure the item is destroyed.": "Başarısız olursa eşya parçalanır.",
  "+{n} extra lines unchanged": "+{n} ek satır değişmez",
  "+{n} extra line unchanged": "+{n} ek satır değişmez",
  "Clan grade {n} or better": "Klan derecesi {n} veya daha iyi",
  "Restores {n} HP": "{n} HP yeniler",
  "Restores {n} MP": "{n} MP yeniler",
  "Remove {item}": "{item} çıkar",
  "Drag items from your bag here to sell them.": "Satmak için çantandaki eşyaları buraya sürükle.",
  "Click an item to take it back.": "Geri almak için eşyaya tıkla.",
  Total: "Toplam",
  "+ Materials": "+ Malzemeler",
  Clear: "Temizle",
  "Tap to take it out": "Çıkarmak için dokun",
  "Drag an item here": "Eşyayı buraya sürükle",
  "Drag a weapon, armor piece or jewel from your bag into the slot (or double tap it). Drop a Best Upgrade Scroll or a Fortune Stone here for better odds.":
    "Çantandan bir silah, zırh parçası ya da takıyı yuvaya sürükle (veya çift dokun). Daha iyi şans için buraya bir En İyi Yükseltme Kağıdı ya da Şans Taşı bırak.",
  "+{n} is the highest level for this item.": "+{n} bu eşyanın en yüksek seviyesi.",
  "Jewelry Scroll": "Takı Kağıdı",
  "identical pieces (same +)": "aynı parça (aynı +)",
  "Always works": "Her zaman başarılı",
  Merge: "Birleştir",
  "Upgrade Scroll": "Yükseltme Kağıdı",
  "No scroll needed": "Kağıt gerekmez",
  "Fortune Stone": "Şans Taşı",

  // Power Up Store
  Featured: "Öne çıkanlar",
  "What's new": "Yenilikler",
  "Gold Premium": "Gold Premium",
  "Faster leveling": "Daha hızlı seviye",
  "Bonus XP, NP, gold": "Ek XP, NP, altın",
  Cloaks: "Pelerinler",
  "Use in Hearthmoor: become the other race, and join the other nation. You leave your clan and party.":
    "Hearthmoor'da kullan: diğer ırka geçersin ve diğer ulusa katılırsın. Klanından ve partinden ayrılırsın.",
  "Use: become the other gender.": "Kullan: diğer cinsiyete geçersin.",
  "Change to the other race and nation? You leave your clan and party, and your character loads again.":
    "Diğer ırka ve ulusa geçilsin mi? Klanından ve partinden ayrılırsın, karakterin yeniden yüklenir.",
  "Change to the other gender? Your character loads again.":
    "Diğer cinsiyete geçilsin mi? Karakterin yeniden yüklenir.",
  Change: "Değiştir",
  "Read it in Hearthmoor: a race change happens on neutral ground":
    "Hearthmoor'da kullan: ırk değişimi tarafsız bölgede yapılır",
  "Hand your clan to another member first: a clan stays one nation":
    "Önce klanını başka bir üyeye devret: bir klan tek ulustan olur",
  "Close your stall first: your items are on sale in your nation's market":
    "Önce tezgâhını kapat: eşyaların ulusunun pazarında satışta",
  Reward: "Ödül",
  "Ranking reward: the first of the nation's monthly NP ranking wears it":
    "Sıralama ödülü: ulusunun aylık NP sıralamasında 1. olan giyer",
  "Ranking reward: the first of each nation in National Points of all time claims it from the Herald in Hearthmoor, and keeps it while holding the place":
    "Sıralama ödülü: tüm zamanların Ulusal Puan sıralamasında her ulusun 1.'si Hearthmoor'daki Habercinden alır, o sırada kaldığı sürece onda kalır",
  "{title}: #{n} of the nation this month": "{title}: bu ay ulusunun {n}. sırası",
  "{title}: #{n} of the nation of all time": "{title}: tüm zamanlarda ulusunun {n}. sırası",
  "Each player shows one symbol: boxed for their place of all time (by the NP earned in the game), which comes first; otherwise plain for this month's place.":
    "Her oyuncu tek simge taşır: önce tüm zamanlardaki sırasına (oyunda kazanılan NP'ye göre) bakılır, kutulu gösterilir; yoksa bu ayın sırası kutusuz gösterilir.",
  "The first of each nation of all time claims the <b>{cloak}</b> from the Herald in Hearthmoor and keeps it while holding the place: twice the stats of the Cloak of the Paragon.":
    "Tüm zamanlarda her ulusun 1.'si <b>{cloak}</b> ödülünü Hearthmoor'daki Habercinden alır, o sırada kaldığı sürece onda kalır: Kusursuzlar Pelerini'nin iki katı stat.",
  "A ranking reward stays with you while you hold the place":
    "Sıralama ödülü, o sırada kaldığın sürece sende kalır",
  "Your place does not earn that reward": "Sıran bu ödülü kazandırmıyor",
  "You already have it": "Bu zaten sende",
  "First of your nation in National Points of all time":
    "Tüm zamanların Ulusal Puan sıralamasında ulusunun 1.'si",
  "Top {n} of your nation in National Points of all time":
    "Tüm zamanların Ulusal Puan sıralamasında ulusunun ilk {n}'i",
  "First of your nation in National Points this month":
    "Bu ayın Ulusal Puan sıralamasında ulusunun 1.'si",
  "Top {n} of your nation in National Points this month":
    "Bu ayın Ulusal Puan sıralamasında ulusunun ilk {n}'i",
  Yours: "Sende",
  Claim: "Teslim al",
  "Not earned": "Kazanılmadı",
  "A reward stays yours while you hold the place; when someone takes it, the reward goes back.":
    "Ödül, o sırada kaldığın sürece sende kalır; biri sıranı alırsa ödül geri alınır.",
  "Herald of Champions: ranking rewards": "Şampiyonlar Habercisi: sıralama ödülleri",
  "Bonus XP, gold, drops": "Ek XP, altın, drop",
  "+XP, gold and drops": "+XP, altın ve drop",
  "Drop rate": "Drop şansı",
  "A cloak that flows behind you, with its own light. {n} looks, and every cloak gives the same bonus:":
    "Arkanda dalgalanan, kendi ışığı olan bir pelerin. {n} görünüm var ve her pelerin aynı bonusu verir:",
  "See the cloaks": "Pelerinleri gör",
  "Worn in the Cloak slot of your inventory, in place of another cloak: one cloak at a time. The bonus works while you wear it. Lasts {n} days from the purchase.":
    "Çantandaki Pelerin yuvasında, başka bir pelerinin yerine giyilir: aynı anda tek pelerin. Bonus giydiğin sürece geçerlidir. Satın alındıktan sonra {n} gün sürer.",
  New: "Yeni",
  Skins: "Kostümler",
  "Armor looks": "Zırh görünümleri",
  "Hand Glows": "El Parıltıları",
  "Orbs on your hands": "Ellerinde küreler",
  "Fortune Stones": "Şans Taşları",
  "Better upgrade odds": "Daha iyi yükseltme şansı",
  Gems: "Elmaslar",
  "Top up your balance": "Bakiyeni yükle",
  Gold: "Altın",
  "<b>+{n}%</b> experience from monsters": "Canavarlardan <b>+%{n}</b> tecrübe",
  "<b>+{n}%</b> gold from loot": "Ganimetten <b>+%{n}</b> altın",
  "<b>+{n}%</b> item drop chance": "<b>+%{n}</b> eşya düşme şansı",
  "<b>+{n}%</b> NP from player kills": "Oyuncu öldürmelerinden <b>+%{n}</b> NP",
  "<b>Priority entry</b> when the server is full": "Sunucu doluyken <b>öncelikli giriş</b>",
  "<b>No XP lost</b> when a monster kills you": "Bir canavar seni öldürdüğünde <b>XP kaybı yok</b>",
  "XP lost when a monster kills you": "Canavara ölünce XP kaybı",
  "{n}% of the level": "Seviyenin %{n} kadarı",
  "For <b>every character</b> on your account": "Hesabındaki <b>her karakter</b> için",
  "Power Up Store": "Power Up Mağazası",
  "+ Add gems": "+ Elmas ekle",
  "Need {n} more gems": "{n} elmas daha gerekli",
  "Gold Premium active: {n} day left": "Gold Premium aktif: {n} gün kaldı",
  "Gold Premium active: {n} days left": "Gold Premium aktif: {n} gün kaldı",
  "Gems are shared by every character on your account":
    "Elmaslar hesabındaki tüm karakterler arasında ortaktır",
  "Use one at the blacksmith when you upgrade a weapon or armor: that roll's success chance is <b>{mult}x</b> (a 12% step becomes {pct}%). One stone per roll, used whether it succeeds or not.":
    "Demircide bir silah ya da zırh yükseltirken bir tane kullan: o denemenin başarı şansı <b>{mult}x</b> olur (%12'lik bir adım %{pct} olur). Her denemede bir taş gider, başarılı olsa da olmasa da.",
  "{n}% off": "%{n} indirim",
  "{n} gems each": "Tanesi {n} elmas",
  "One stone": "Tek taş",
  "Payments are not live yet. In development a pack adds its gems for free.":
    "Ödemeler henüz aktif değil. Geliştirme ortamında paket elmaslarını ücretsiz ekler.",
  "Gem packs are coming soon.": "Elmas paketleri yakında geliyor.",
  "Gems buy everything in this store and are shared by every character on your account.":
    "Elmaslarla bu mağazadaki her şey alınır ve hesabındaki tüm karakterler arasında ortaktır.",
  "Best value": "En avantajlı",
  "{n} bonus": "{n} bonus",
  gems: "elmas",
  "+{xp}% XP, +{gold}% gold": "+%{xp} XP, +%{gold} altın",
  "Worn on your back": "Sırtında taşınır",
  "Recolor your armor": "Zırhını yeniden renklendir",
  "Orbs around your fists": "Yumruklarının etrafında küreler",
  "{n}x upgrade odds": "{n}x yükseltme şansı",
  "Spread them on your back, and gain with every fight. {n} looks, and every pair gives the same bonus:":
    "Sırtında aç, her dövüşte kazan. {n} görünüm var ve her çift aynı bonusu verir:",
  "See the wings": "Kanatları gör",
  "from {price}": "{price} itibaren",
  "<b>Gold Premium is active</b>: {n} day left.": "<b>Gold Premium aktif</b>: {n} gün kaldı.",
  "<b>Gold Premium is active</b>: {n} days left.": "<b>Gold Premium aktif</b>: {n} gün kaldı.",
  "<b>Gold Premium</b>: level faster and loot more on every character.":
    "<b>Gold Premium</b>: her karakterde daha hızlı seviye atla, daha çok ganimet topla.",
  Extend: "Uzat",
  "Get it": "Satın al",
  "Active, {n} day left. Buying again adds {add} days on top.":
    "Aktif, {n} gün kaldı. Tekrar almak {add} gün daha ekler.",
  "Active, {n} days left. Buying again adds {add} days on top.":
    "Aktif, {n} gün kaldı. Tekrar almak {add} gün daha ekler.",
  "Not active": "Aktif değil",
  "{n} days": "{n} gün",
  Extra: "Ek",
  Without: "Olmadan",
  Standard: "Standart",
  "With Gold Premium": "Gold Premium ile",
  None: "Yok",
  "Item drop chance": "Eşya düşme şansı",
  "NP from player kills": "Oyuncu öldürmelerinden NP",
  "Entry when the server is full": "Sunucu doluyken giriş",
  "Wait in line": "Sırada bekler",
  "First in line": "Sıranın önünde",
  "Gold picked up by itself": "Altın kendiliğinden toplanır",
  No: "Hayır",
  "Within {n} m": "{n} m içinde",
  Characters: "Karakterler",
  "Every character on the account": "Hesaptaki her karakter",
  Wearing: "Giyiliyor",
  Owned: "Sahipsin",
  "Take off": "Çıkar",
  Wear: "Giy",
  "Yours for {n} days on every character; stats stay the same. Buying it again adds {n} days.":
    "{n} gün boyunca tüm karakterlerinde senin; statlar değişmez. Tekrar alırsan {n} gün eklenir.",
  "{n} days left, until {date}": "{n} gün kaldı, bitiş: {date}",
  "+{n} days": "+{n} gün",
  "{n}d": "{n}g",
  "Until {date}": "Bitiş: {date}",
  "Shifts through every color.": "Tüm renkler arasında geçiş yapar.",
  "A glowing orb around each hand. It goes to your bag: wear it in the Glow slot of your inventory. Lasts {n} days from the purchase.":
    "Her elin etrafında parlayan bir küre. Çantana gelir: çantandaki Parıltı yuvasında giy. Satın alındıktan sonra {n} gün sürer.",
  "You are wearing one.": "Şu an bir tane giyiyorsun.",
  "Worn on your back and seen by everyone. The bonus works while you wear them. They go to your bag: wear them in the Wings slot of your inventory. Last {n} days from the purchase.":
    "Sırtında taşınır ve herkes görür. Bonus giydiğin sürece geçerlidir. Çantana gelir: çantandaki Kanat yuvasında giy. Satın alındıktan sonra {n} gün sürer.",
  "You are wearing a pair.": "Şu an bir çift giyiyorsun.",
  "Adds {n} days of Gold Premium to your account.": "Hesabına {n} gün Gold Premium ekler.",
  "Goes to your bag. Lasts {n} days and cannot be traded or thrown away.":
    "Çantana gelir. {n} gün sürer, takas edilemez ve atılamaz.",
  "Yours for {n} days, on every character. Bought again, it runs {n} days longer.":
    "{n} gün boyunca her karakterinde senin. Tekrar alınırsa {n} gün uzar.",
  "Goes to your bag.": "Çantana gelir.",
  "Confirm purchase": "Satın almayı onayla",
  "Buy {item}?": "{item} satın alınsın mı?",
  Price: "Fiyat",
  "Balance after": "Sonraki bakiye",
  "Buy now": "Hemen al",

  // Stalls and trades
  "That item can't be sold to players": "Bu eşya oyunculara satılamaz",
  "A stall holds {n} items": "Bir tezgâh en fazla {n} eşya alır",
  "Price in gold": "Altın olarak fiyat",
  Remove: "Çıkar",
  "Open a stall": "Tezgâh aç",
  'Drag items from your bag here and set a price (up to {n} gold, "1.5m" works). The stall stays where you open it; click it later to close it.':
    'Çantandan eşyaları buraya sürükle ve fiyat belirle ({n} altına kadar, "1.5m" de olur). Tezgâh açtığın yerde kalır; kapatmak için sonra ona tıkla.',
  "Your stall": "Senin tezgâhın",
  "{n} of {max} items on sale. Sales pay you wherever you are.":
    "{max} eşyadan {n} tanesi satışta. Satışların parası nerede olursan ol sana gelir.",
  "Click again to close": "Kapatmak için tekrar tıkla",
  "Stall name (e.g. Cheap swords)": "Tezgâh adı (ör. Ucuz kılıçlar)",
  "Drop items here": "Eşyaları buraya bırak",
  "Close stall": "Tezgâhı kapat",
  "Open stall": "Tezgâhı aç",
  "{name}'s stall": "{name} tezgâhı",
  Confirm: "Onayla",
  "Sold out": "Tükendi",
  "You have {n} gold.": "{n} altının var.",
  "<b>{name}</b> wants to trade with you.": "<b>{name}</b> seninle takas yapmak istiyor.",
  Decline: "Reddet",
  Trade: "Takas",
  "Click to take back": "Geri almak için tıkla",
  "Trade with {name}": "{name} ile takas",
  "Drag items from your bag to your side. Any change resets both accepts.":
    "Çantandan eşyaları kendi tarafına sürükle. Her değişiklik iki onayı da sıfırlar.",
  "Cancel trade": "Takası iptal et",
  You: "Sen",
  Accepted: "Onaylandı",
  "Gold to give": "Verilecek altın",
  "Waiting for them": "Karşı taraf bekleniyor",
  Accept: "Kabul et",

  // Warehouse
  "Double-click to take": "Almak için çift tıkla",
  Warehouse: "Depo",
  "Double-click a bag item to store it, a stored item to take it back.":
    "Saklamak için çantadaki eşyaya, geri almak için depodaki eşyaya çift tıkla.",
  stored: "depoda",
  Amount: "Miktar",
  "Gold amount": "Altın miktarı",
  Deposit: "Yatır",
  Withdraw: "Çek",
  "{used} / {total} slots · You carry {gold} gold":
    "{used} / {total} yuva · Üzerinde {gold} altın var",

  // Riftstone Reel
  Green: "Yeşil",
  Blue: "Mavi",
  Violet: "Mor",
  Empty: "Boş",
  "{n} gold": "{n} altın",
  Mystery: "Gizem",
  "The stone was empty.": "Taş boş çıktı.",
  "+{n} gold": "+{n} altın",
  "Riftstone Reel": "Yarık Taşı Çarkı",
  "Break a coffer won in the Crystal Clash.": "Kristal Çatışması'nda kazandığın bir sandığı kır.",
  "Break a Riftstone from the Umbral Rift. It may hold a fortune, or nothing.":
    "Umbral Yarığı'ndan gelen bir Yarık Taşı kır. İçinden servet de çıkabilir, hiçbir şey de.",
  "Press Start, then Stop": "Önce Başlat, sonra Durdur'a bas",
  Start: "Başlat",
  Stop: "Durdur",

  // Upgrade animation
  "The hammer falls...": "Çekiç iniyor...",
  "Success! {item} +{n}": "Başarılı! {item} +{n}",
  "{item} shattered": "{item} parçalandı",
  "Failed. Still +{n}": "Başarısız. Hâlâ +{n}",
  "The pieces fused into one.": "Parçalar tek bir parçada birleşti.",
  "The steel took the blow ({n}% chance, with a Fortune Stone).":
    "Çelik darbeye dayandı (%{n} şans, Şans Taşı ile).",
  "The steel took the blow ({n}% chance).": "Çelik darbeye dayandı (%{n} şans).",
  "The anvil kept nothing but sparks.": "Örste kıvılcımlardan başka bir şey kalmadı.",
  "Nothing lost but gold and a scroll.": "Altın ve bir kağıt dışında bir şey kaybolmadı.",

  // Skill book and bar
  "Tap a slot for <b>{skill}</b>": "<b>{skill}</b> için bir yuvaya dokun",
  "Tap a skill, then tap a slot. Tap a slot to move it.":
    "Bir yeteneğe, sonra bir yuvaya dokun. Taşımak için yuvaya dokun.",
  "Drag skills into the bar, or click one, then a slot. Drag a slot out to empty it.":
    "Yetenekleri bara sürükle ya da birine, sonra bir yuvaya tıkla. Boşaltmak için yuvayı dışarı sürükle.",
  Skills: "Yetenekler",
  "{n} of {total} learned": "{total} yetenekten {n} tanesi öğrenildi",
  "Empty slot {n}": "Boş yuva {n}",
  "Level {n}": "Seviye {n}",
  "Key {n}": "Tuş {n}",
  "Not on bar": "Barda değil",
  "Lv {n}": "Sv. {n}",

  // Skill tooltips
  defense: "savunma",
  "attack power": "saldırı gücü",
  "damage taken": "alınan hasar",
  "move speed": "hareket hızı",
  "Deals {hits} hits of {pct} attack power to up to {n} enemies in front":
    "Öndeki en fazla {n} düşmana {hits} kez {pct} saldırı gücünde vurur",
  "Deals {pct} attack power to up to {n} enemies in front":
    "Öndeki en fazla {n} düşmana {pct} saldırı gücünde hasar verir",
  "Deals {hits} hits of {pct} attack power to all enemies within {r} m":
    "{r} m içindeki tüm düşmanlara {hits} kez {pct} saldırı gücünde vurur",
  "Deals {pct} attack power to all enemies within {r} m":
    "{r} m içindeki tüm düşmanlara {pct} saldırı gücünde hasar verir",
  "Deals {hits} hits of {pct} attack power to all enemies in a {r} m circle":
    "{r} m'lik bir daire içindeki tüm düşmanlara {hits} kez {pct} saldırı gücünde vurur",
  "Deals {pct} attack power to all enemies in a {r} m circle":
    "{r} m'lik bir daire içindeki tüm düşmanlara {pct} saldırı gücünde hasar verir",
  "Deals {hits} hits of {pct} attack power": "{hits} kez {pct} saldırı gücünde vurur",
  "Deals {pct} attack power": "{pct} saldırı gücünde hasar verir",
  " ({pct} from stealth)": " (gizlenmeden {pct})",
  "{chance}% chance: slows by {pct}% for {time}":
    "%{chance} şans: {time} boyunca %{pct} yavaşlatır",
  "Slows by {pct}% for {time}": "{time} boyunca %{pct} yavaşlatır",
  "{chance}% chance: stuns for {time}": "%{chance} şans: {time} boyunca sersemletir",
  "Stuns for {time}": "{time} boyunca sersemletir",
  "{chance}% chance: roots for {time}": "%{chance} şans: {time} boyunca köklendirir",
  "Roots for {time}": "{time} boyunca köklendirir",
  "{chance}% chance: freezes for {time}": "%{chance} şans: {time} boyunca dondurur",
  "Freezes for {time}": "{time} boyunca dondurur",
  " (players only)": " (yalnızca oyuncular)",
  "Poisons for {pct} attack power over {time}.":
    "{time} boyunca {pct} saldırı gücünde zehir hasarı verir.",
  "Heals you and your party within {r} m for {pct} attack power.":
    "Seni ve {r} m içindeki parti üyelerini {pct} saldırı gücü kadar iyileştirir.",
  "Heals for {pct} attack power.": "{pct} saldırı gücü kadar iyileştirir.",
  "Heals for {pct} attack power over {time}.":
    "{time} boyunca {pct} saldırı gücü kadar iyileştirir.",
  "Gives you and your party {amount} {stat} for {time}.":
    "Sana ve partine {time} boyunca {amount} {stat} verir.",
  "Gives you {amount} {stat} for {time}.": "Sana {time} boyunca {amount} {stat} verir.",
  "+{pct}% damage taken": "+%{pct} alınan hasar",
  "Curses the enemy: {worse} for {time}.": "Düşmanı lanetler: {time} boyunca {worse}.",
  "Forces enemies within {r} m to attack you.": "{r} m içindeki düşmanları sana saldırmaya zorlar.",
  "Dashes to the target.": "Hedefe atılır.",
  "Teleports {d} m forward and breaks roots and slows.":
    "{d} m ileri ışınlanır, kök ve yavaşlatma etkilerini kırar.",
  "Stealth for {time} with +{pct}% move speed. Enemies lose track of you. Attacking breaks it.":
    "{time} boyunca +%{pct} hareket hızıyla gizlenir. Düşmanlar seni kaybeder. Saldırmak gizlenmeyi bozar.",
  "Removes poisons, slows, roots, freezes and curses from you and your party within {r} m.":
    "Senden ve {r} m içindeki parti üyelerinden zehir, yavaşlatma, kök, dondurma ve lanetleri kaldırır.",
  "Removes poisons, slows, roots, freezes and curses.":
    "Zehir, yavaşlatma, kök, dondurma ve lanetleri kaldırır.",
  "Brings every party member in this zone who is out of combat to your side.":
    "Bu bölgede savaşta olmayan tüm parti üyelerini yanına getirir.",
  "{time} cast": "{time} büyü süresi",
  Instant: "Anında",
  "{time} cooldown": "{time} bekleme süresi",
  "No cooldown": "Bekleme süresi yok",
  "{r} m range": "{r} m menzil",

  // Map
  "PvP zone": "PvP bölgesi",
  "Human homeland": "İnsan toprakları",
  "Orc homeland": "Ork toprakları",
  "Neutral lands": "Tarafsız topraklar",
  "Apothecary: buys your loot": "Aktar: ganimetini satın alır",
  Trader: "Tüccar",
  "Upgrade scrolls": "Yükseltme kağıtları",
  "Blacksmith: sell and upgrade": "Demirci: sat ve yükselt",
  Supplies: "Erzak",
  "Gemcutter: the Riftstone Reel": "Taş Ustası: Yarık Taşı Çarkı",
  "Clan Steward: clan cloaks": "Klan Kâhyası: klan pelerinleri",
} satisfies Record<string, string>;
